const STORAGE_KEY = 'a-little-loco-progress'

// Storage can be unavailable (private mode, blocked site data) or hold corrupted data.
// Progress is a nice-to-have, so failures degrade to "nothing completed" instead of throwing
// inside the frame loop.
function readProgress(): number[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]')
    return Array.isArray(parsed) ? parsed.filter((n): n is number => Number.isInteger(n)) : []
  } catch {
    return []
  }
}

export function markLevelComplete(level: number) {
  const progress = readProgress()
  if (progress.includes(level)) return

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...progress, level]))
  } catch {
    // Quota exceeded or storage blocked: keep playing without persisting.
  }
}

export function isLevelComplete(level: number) {
  return readProgress().includes(level)
}
